import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class DashboardUrlChartSettingsRoute extends Route {
  @service router;
  @service session;

  beforeModel() {
    if (this.session.user?.isLimited) {
      this.router.transitionTo('dashboard.url.chart');
    }
  }
}
